/* eslint-disable */
import React from 'react';
import {
    Datagrid,
    TextField,
    BooleanField,
    Show,
    SimpleShowLayout,
    DateField,
    Create,
    SimpleForm,
    Edit,
} from 'react-admin';
import { EditToolbar } from '../layout/EditToolbar';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { SwList } from '../lib/SwList';
import { BooleanInput, TextInput } from '../lib/wrappers/Inputs';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { BaseFilter, ShowTitleByDescription } from './Scaffolding';

export const QualificationAimLabels = {
    pageTitle: 'Qualification Aims ',
    Title: 'Code',
};

export const QualificationAimList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={QualificationAimLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField
                        label={QualificationAimLabels.Title}
                        source="Title"
                    />
                    <BooleanField source="current" />
                    <TextField source="description" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const QualificationAimShow = (props) => (
    <Show title={<ShowTitleByDescription />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField label={QualificationAimLabels.Title} source="Title" />
            <TextField source="description" />
            <BooleanField source="current" />
            <DateField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);

export const QualificationAimCreate = (props) => (
    <Create {...props} redirect="edit">
        <SimpleForm>
            <TextInput label={QualificationAimLabels.Title} source="Title" />
            <TextInput source="description" />
            <BooleanInput source="current" />
        </SimpleForm>
    </Create>
);

export const QualificationAimEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit title={<ShowTitleByDescription />} {...props} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="id" disabled />
                    <TextInput
                        label={QualificationAimLabels.Title}
                        source="Title"
                    />
                    <TextInput source="description" />
                    <BooleanInput source="current" />
                    <TextInput source="created_at" disabled />
                    <TextInput source="updated_at" disabled />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};
